import { Spin } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { AlertColumn } from './cards/AlertColumn';
import {
  ALERT_COLUMNS,
  getDisplayableNotifications
} from '../../utils/alertColumns';

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 18px;
  align-items: start;
`;

/**
 * ShowAlerts component for displaying the alerts grouped in columns.
 * @component
 * @param {Object} props - The properties of the ShowAlerts component.
 * @param {Array} props.notifications - An array of notifications.
 * @param {Function} props.t - Translation function for internationalization.
 * @param {boolean} props.forceRefresh - Boolean flag for forcing a data refresh.
 * @param {Function} props.setForceRefresh - Function to set the forceRefresh state.
 * @param {Function} props.message - Function for displaying messages.
 * @param {Function} props.dispatchAPI - Function for dispatching API calls.
 * @param {Object} props.user - User object containing user information.
 * @param {string} props.user._id - User ID.
 * @param {boolean} props.loading - Boolean flag indicating if data is loading.
 * @returns {JSX.Element} - JSX element representing the ShowAlerts component.
 */
export const ShowAlerts = ({
  notifications,
  t,
  forceRefresh,
  setForceRefresh,
  message,
  dispatchAPI,
  user,
  loading
}) => {
  const displayable = getDisplayableNotifications(notifications);

  return (
    <Spin spinning={loading}>
      <StyledGrid>
        {ALERT_COLUMNS.map((column) => (
          <AlertColumn
            key={column.key}
            column={column}
            notifications={displayable.filter((notification) =>
              column.refs.includes(notification.item?.ref)
            )}
            t={t}
            forceRefresh={forceRefresh}
            setForceRefresh={setForceRefresh}
            message={message}
            dispatchAPI={dispatchAPI}
            user={user}
          />
        ))}
      </StyledGrid>
    </Spin>
  );
};

ShowAlerts.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  t: PropTypes.func.isRequired,
  forceRefresh: PropTypes.bool.isRequired,
  setForceRefresh: PropTypes.func.isRequired,
  message: PropTypes.func.isRequired,
  dispatchAPI: PropTypes.func.isRequired,
  user: PropTypes.shape({ _id: PropTypes.string }).isRequired,
  loading: PropTypes.bool.isRequired
};
